(function () {

    "use strict";

    angular.module("app").factory("UnloadHandler", UnloadHandlerFactory);

    UnloadHandlerFactory.$inject = ["$window"];
    function UnloadHandlerFactory($window) {
        const callbacks = {
            ShouldInvoke: () => true,
            Invoke: angular.noop
        };

        const eventNames = { Default: "beforeunload", Legacy: "onbeforeunload" };

        return {
            Register: register,
            Clear: clear
        };

        function register(invokeCallback, shouldInvokeCallback) {
            if (!angular.isFunction(invokeCallback)) {
                console.warn("Unexpected parameter - invokeCallback, expecting a function");
            }

            callbacks.Invoke = invokeCallback;

            if (angular.isFunction(shouldInvokeCallback)) {
                callbacks.ShouldInvoke = shouldInvokeCallback;
            }

            addUnloadEvent();
        }

        function clear() {
            removeUnloadEvent();

            callbacks.ShouldInvoke = () => true;
            callbacks.Invoke = angular.noop;
        }

        function addUnloadEvent() {
            if ($window.addEventListener) {
                $window.addEventListener(eventNames.Default, handleUnloadEvent);
            }
            else {
                //For IE browsers
                $window.attachEvent(eventNames.Legacy, handleUnloadEvent);
            }
        }

        function removeUnloadEvent() {
            if ($window.removeEventListener) {
                $window.removeEventListener(eventNames.Default, handleUnloadEvent);
            }
            else {
                $window.detachEvent(eventNames.Legacy, handleUnloadEvent);
            }
        }

        function handleUnloadEvent(event) {
            if (callbacks.ShouldInvoke()) {
                event.returnValue = callbacks.Invoke();
            }
        }
    }
})();